import {InputOrTextArea, InputProps} from '@local/ui/components'
import {forwardRef} from 'react'

export const TextArea = forwardRef<HTMLDivElement, InputProps>(({...props}: InputProps, ref) => {
	return <InputOrTextArea as='textarea' ref={ref} {...props} />
})
